import React, { Component, ReactElement } from "react";
import { JQModal } from "./Utils";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil } from "@eres/core";

export interface Props {
	id: string;
	onDismiss?: () => void;
	autoOpenMount?: boolean;
	ariaLabel?: string;
	tabIndex?: number;
	showCloseButton?: boolean;
	title?: string | LocaleValue;
	showIcon?: boolean;
	iconClass?: string;
	iconClassWrapper?: string;
	clickOutsideToDismiss?: boolean;
	contentHeight?: string;
	width?: string;
	noTitle?: boolean;
	modalMainContainer?: string;
	modalSubContainer?: string;
	closeClass?: string;
	closeSpanClass?: string;
	modalBodyContainer?: string;
	header?: ReactElement;
	modalFooterContainer?: string;
	footer?: ReactElement;
}

class Popup extends Component<Props> {
	static defaultProps: Partial<Props> = {
		modalMainContainer: "modal fade dashboard-popup",
		modalSubContainer: "modal-dialog modal-dialog-centered",
		tabIndex: -1,
		showCloseButton: true,
		title: LVStrings.my_dld,
		showIcon: true,
        iconClass: "material-icons-outlined",
        iconClassWrapper: "icon-modal-wrap svginfo mb-3",
		clickOutsideToDismiss: true,
		noTitle: false,
		closeClass: "close modal-close-svg-icon",
		modalBodyContainer: "modal-body p-3",
		modalFooterContainer: "modal-footer d-flex justify-content-center p-2",
	};

	public static Dismiss( id: string ) {
		JQModal( id ).hide();
	}

	render() {
		const cp: any = {};
		if ( !this.props.clickOutsideToDismiss ) {
			cp[ "data-bs-backdrop" ] = "static";
		}
		const dp: any = {};
		if ( this.props.width ) {
			dp[ "style" ] = { width: this.props.width, "max-width": this.props.width };
		}
		const bp: any = {};
		if ( this.props.contentHeight ) {
			bp.style = { height: this.props.contentHeight };
		}
		return (
			<div
				className={ this.props.modalMainContainer }
				id={ this.props.id }
				aria-labelledby={ this.props.ariaLabel }
				role="dialog"
				aria-hidden="true" tabIndex={ this.props.tabIndex }
				{ ...cp }
			>
				<div className={ this.props.modalSubContainer } role="document" { ...dp }>
					<div className="modal-content">
						{ this.props.header }
						{ this.props.showCloseButton && !this.props.noTitle &&
							<div className="modal-header">
								{ !this.props.noTitle &&
									<h6 className="modal-title">{ LocaleUtil.getLocalValue( this.props.title ) }</h6>
								}
								{ this.props.showCloseButton &&
									<button
										aria-label="Close" className={ this.props.closeClass } data-bs-dismiss="modal"
										type="button">
										{ this.props.closeSpanClass ?
											<span className={ this.props.closeSpanClass }/> :
											<span className="close-svg-icon"></span> }
										<span className="sr-only">{ Strings.close }</span>
									</button>
								}
							</div>
						}
						<div className={ this.props.modalBodyContainer } { ...bp }>
							{ this.props.showIcon &&
								<div className={ this.props.iconClassWrapper }>
									<i className={ this.props.iconClass }>info</i>
								</div>
							}
							{ this.props.children }
						</div>
						{ this.props.footer && <div className={ this.props.modalFooterContainer }>
							{ this.props.footer }
						</div> }
					</div>
				</div>
			</div>
		);
	}

	public dissmiss = () => {
		JQModal( this.props.id ).hide();
	};
	public toggle = () => {
		JQModal( this.props.id ).toggle();
	};
	public show = () => {
		JQModal( this.props.id ).show();
	};

	componentDidMount(): void {
		window.$( "#" + this.props.id ).on( "hidden.bs.modal", () => {
			if ( this.props.onDismiss ) this.props.onDismiss();
		} );
		if ( this.props.autoOpenMount ) {
			this.show();
		}
	}
}

export default Popup;

export class CloseButton extends Component {
	render() {
		return <div className="form-group mb-4 mb-0 text-center">
			<button
				aria-label="Close" className="btn btn_1" data-bs-dismiss="modal"
				type="button">{ Strings.close }
			</button>
		</div>;
	}
}
